import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Navbar from "../../../components/Navbar/Navbar";
import Hero from "../../../components/Hero/Hero";
import Footer from "../../../components/Footer/Footer";
import ImageGallery from "../../../components/ImageGallery/ImageGallery";

import classes from "./Project.module.scss";

const Project = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const project = location.state?.project;

  const [state, setState] = useState({
    index: -1,
    images: [],
  });

  useEffect(() => {
    if (!project) {
      navigate("/projects");
      return;
    }

    setState((prevState) => ({
      ...prevState,
      images: [...project.images],
    }));

    return () => {
      setState({
        index: -1,
        images: [],
      });
    };
  }, [project, navigate]);

  const goBack = () => {
    navigate("/projects");
  };

  if (!project) return null;

  return (
    <div className={classes["project"]}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{project.title} | Unified Building Group</title>
        <meta
          name="description"
          content={`View the ${project.title} project by Unified Building Group, including project value, completed works and project gallery.`}
        />
      </Helmet>

      <Navbar />

      <Hero
        image={project.img}
        title={project.title}
        slogan="Project details and completed works"
      />

      <main>
        <section className={classes["description"]}>
          <div className={classes["project-summary"]}>
            <div className={classes["summary-card"]}>
              <span>Completed</span>
              <strong>{project.completed || "Available on request"}</strong>
            </div>

            <div className={classes["summary-card"]}>
              <span>Project Value</span>
              <strong>{project.projectValue || "Available on request"}</strong>
            </div>
          </div>

          <div className={classes["project-details"]}>
            <p className={classes["eyebrow"]}>Project overview</p>
            <h1>{project.title}</h1>

            {project.description && <p>{project.description}</p>}

            {project.bulletPoints.length > 0 && (
              <div className={classes["scope-box"]}>
                <h2>Scope of works</h2>
                <ul>
                  {project.bulletPoints.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              </div>
            )}

            <button onClick={goBack}>View Projects</button>
          </div>
        </section>

        <section className={classes["gallery"]}>
          <div className={classes["gallery-header"]}>
            <p className={classes["eyebrow"]}>Project gallery</p>
            <h2>Completed work</h2>
          </div>

          <ImageGallery images={state.images} />
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Project;
